import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/from';
import 'rxjs/add/operator/mergeMap';
import { mapResponseToIssue } from '../../services/issue-view-update/index.tsx';
import { mapResponseToIssueParent } from '../../services/issue-view-update/issue-parent/index.tsx';
import {
	ISSUE_VIEW_UPDATE,
	type IssueViewUpdateAction,
} from '../../state/actions/issue-view-update/index.tsx';
import { getCards } from '../../state/selectors/cards/index.tsx';
import { getIssueParents } from '../../state/selectors/issue-parent/index.tsx';
import type { ActionsObservable, MiddlewareAPI } from '../../state/types.tsx';

export const issueViewUpdateEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$.ofType(ISSUE_VIEW_UPDATE).mergeMap((action: IssueViewUpdateAction) => {
		const state = store.getState();
		const { payload } = action;
		const targetIssueParent = getIssueParents(state)[payload.issueId];

		if (targetIssueParent) {
			const actionsFromMappedResponse = mapResponseToIssueParent(targetIssueParent, state, payload);

			return actionsFromMappedResponse
				? Observable.from([actionsFromMappedResponse])
				: Observable.empty<never>();
		}

		// TODO: Add getIssueChildren(state)[payload.issueId] when issue children is supported in Backlog (CATBUS-2200)
		const targetIssue = getCards(state)[payload.issueId];
		const actionsFromMappedResponse = mapResponseToIssue(targetIssue, state, payload);

		return actionsFromMappedResponse
			? Observable.from([actionsFromMappedResponse])
			: Observable.empty<never>();
	});
